import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LAZY_VIEW_ENTRY_COMPONENT } from '../lazy-view/lazy-view-entry-component.injection-token';
import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { LeftNavReactContentDirective } from './left-nav-react-content.directive';
import { LeftNavReactComponent } from './left-nav-react.component';

@NgModule({
    imports: [
        CommonModule,
        LazyViewModule
    ],
    declarations: [
        LeftNavReactComponent,
        LeftNavReactContentDirective
    ],
    providers: [
        { provide: LAZY_VIEW_ENTRY_COMPONENT, useValue: LeftNavReactComponent }
    ],
    entryComponents: [
        LeftNavReactComponent
    ]
})
export class LeftNavReactModule {
}
